var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_617_6601)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.4759 11.8471C29.9885 11.3541 30.1695 10.6304 29.9484 9.95769C29.7268 9.28499 29.1495 8.80478 28.4403 8.70287L22.1349 7.79855C21.8664 7.75995 21.6343 7.5937 21.5144 7.35334L18.6954 1.71385C18.3789 1.08026 17.7365 0.686523 17.0205 0.686523C16.3051 0.686523 15.6627 1.08026 15.3462 1.71385L12.5267 7.35334C12.4067 7.5937 12.1742 7.75995 11.9056 7.79855L5.60023 8.70338C4.89157 8.80478 4.31433 9.28499 4.09271 9.95769C3.87161 10.6304 4.05256 11.3541 4.56515 11.8471L9.12733 16.2364C9.32183 16.4238 9.411 16.6935 9.36511 16.957L8.28831 23.1554C8.16733 23.8518 8.45152 24.542 9.03086 24.9579C9.60967 25.3743 10.3632 25.4283 10.9978 25.0984L16.6368 22.1719C16.8771 22.0473 17.1639 22.0473 17.4043 22.1719L23.0438 25.0984C23.3192 25.2415 23.6174 25.312 23.9141 25.312C24.2995 25.312 24.6833 25.1931 25.0107 24.9579C25.5901 24.542 25.8743 23.8518 25.7533 23.1554L24.676 16.9575C24.6301 16.6935 24.7193 16.4243 24.9138 16.2369L29.4759 11.8471Z",
    fill: "#12BF66"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_617_6601",
    x: 0,
    y: 0.686523,
    width: 34.041,
    height: 32.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_617_6601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_617_6601",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.2d883dbcba7f5e498d3c94d454de1936.svg";
export { ForwardRef as ReactComponent };